module.exports = __webpack_public_path__ + "static/media/haiti-21-a-0520.e322dae9.jpg";